import { render, staticRenderFns } from "./Rezervari_list.vue?vue&type=template&id=ee5d7150&"
import script from "./Rezervari_list.vue?vue&type=script&lang=js&"
export * from "./Rezervari_list.vue?vue&type=script&lang=js&"
import style0 from "./Rezervari_list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports